export default __webpack_public_path__ + "static/media/bc-six.c2501ecc.svg";